module.exports = ".lista-areas {\r\n  height: 90%;\r\n  overflow-y: auto;\r\n}\r\n\r\n.area-mapa{\r\n    height: 75vh;\r\n}\r\n"